import React, { useEffect, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import Footer from '../../components/footer/Footer'
import Navigation from '../../components/navigation/Navigation'
import './verifyBooking.css'

import queryString from 'query-string'
import { toast, ToastContainer } from 'react-toastify'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'

const renderLoading = () => (
    <div style={{ display: "flex", justifyContent: "center", padding: "1rem" }}>
        <Spinner animation="border" variant="darke" /> 
        <h3 style={{marginLeft: "1rem"}}>Verifying your booking</h3>
    </div>
)

function VerifyBooking() {
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);

        const { transaction_id } = queryString.parse(window.location.search); 

        axios.post(`https://the-outlet-vendor-api.herokuapp.com/bookings/verify`, { "transactionId": transaction_id })
            .then(res => {
                toast("Booking Successfully Verified.", {
                    type: "success",
                    position: "top-right",
                    autoClose: "1000",
                    hideProgressBar: true,
                    closeOnClick: false,
                    pauseOnHover: false,
                    draggable: false,
                    progress: undefined,
                });
                setLoading(false);
            })
            .catch(err => {
                // toast(`Ooop! Something wrong happened. ${err}`, {
                //     type: "error",
                //     position: "top-right",
                //     autoClose: "5000",
                //     hideProgressBar: false,
                //     closeOnClick: false,
                //     pauseOnHover: false,
                //     draggable: false,
                //     progress: undefined,
                // })
                // navigate(`/error`)
            })

    }, [])

  return (
    <div className='verifyBooking'>
        <Navigation background="theme-color" logo='https://res.cloudinary.com/emacon-production/image/upload/v1638427484/the-outlet/Artboard_7_copy_7png_j6chrh.png' />

        <div className='main-section'>
            <div className='section-1'>
                <img src="https://res.cloudinary.com/emacon-production/image/upload/v1648793433/the-outlet/THE_OUTLET_PNG_t6abcu.png" />
            </div>
            <h3 style={{ textAlign: "center", fontWeight: "bold"}}>
                {
                    loading ? renderLoading() : "THANK YOU FOR BOOKING OUR SERVICES"
                }
            </h3>
            {
                loading ? null : <p style={{ textAlign: "center" }}>Your booking has been successfully verified</p>
            }
            
        </div>

        <ToastContainer />

        <Footer/>
    </div>
  )
}

export default VerifyBooking